import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Form, Col } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import { Typeahead } from 'react-bootstrap-typeahead'

import CustomInput from './CustomInput'

function ActividadSecundaria({
  name,
  errorPath,
  field,
  indx,
  actividades,
  actividadesiibb
}) {
  const firstRender = useRef(true)
  const [selected, setSelected] = useState([])
  const [secundaria, setSecundaria] = useState([])
  const { register, setValue, getValues, watch } = useFormContext()
  const location = useLocation()

  const watchSecundaria = watch(`${name}.actividad_secundaria`)
  const watchTipoActividad = watch(`${name}.tipo_codigo_actividad`)

  useEffect(() => {
    if (Number(watchSecundaria) > 0 && firstRender.current) {
      let actividad = (
        watchTipoActividad === 'catID' ? actividades : actividadesiibb
      ).filter((act) => act.value === Number(watchSecundaria))

      if (actividad) {
        if (watchTipoActividad === 'catID') {
          setSelected(actividad)
        } else {
          setSecundaria(actividad)
        }
        firstRender.current = false
      }
    }
  }, [watchSecundaria, watchTipoActividad, actividades, actividadesiibb])

  useEffect(() => {
    setValue(`${name}.actividad_secundaria`, secundaria?.[0]?.value ?? 0, {
      shouldValidate: true
    })
  }, [secundaria, name, setValue])

  return (
    <React.Fragment key={indx}>
      {selected.length > 0 && (
        <Col md={12}>
          <Form.Group>
            <Form.Label>Actividad secundaria anterior</Form.Label>

            <Form.Control
              type="text"
              disabled
              value={
                selected.length > 0
                  ? `${selected[0].id} - ${selected[0].descripcion}`
                  : ''
              }
            />
          </Form.Group>
        </Col>
      )}

      <Col md={6}>
        <Form.Group>
          <Form.Label>{`Actividad secundaria ${indx + 1}`}</Form.Label>

          <input
            name={`${name}.actividad_secundaria`}
            defaultValue=""
            style={{ display: 'none' }}
            ref={register({
              required: {
                value: true,
                message: 'Es necesario seleccionar una actividad.'
              },
              validate: {
                selectedSomething: (value) =>
                  value?.length > 0 || 'Es necesario seleccionar una actividad.'
              }
            })}
          />

          <Typeahead
            id={`${name}.actividad_secundaria`}
            placeholder="Seleccione una actividad comercial"
            paginationText="Mostrar más opciones..."
            labelKey={(option) => `${option.id} - ${option.descripcion}`}
            emptyLabel="No existen actividades para esta búsqueda."
            options={actividadesiibb}
            highlightOnlyResult={true}
            ignoreDiacritics={true}
            disabled={location?.state?.visualizarDatos}
            onChange={(v) => setSecundaria(v)}
            selected={secundaria}
            isValid={
              !errorPath?.actividad_secundaria &&
              getValues(`${name}.actividad_secundaria`) > 0
            }
            isInvalid={!!errorPath?.actividad_secundaria}
          />

          <Form.Control.Feedback type="invalid">
            {errorPath?.actividad_secundaria?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      <CustomInput
        md={3}
        label={`Fecha de inicio ${indx + 1}`}
        as="input"
        type="date"
        min="1900-01-01"
        max="3000-12-31"
        name={`${name}.fecha_inicio`}
        defaultValue={field.fecha_inicio}
        errorPath={errorPath?.fecha_inicio}
        validation={{
          required: {
            value: true,
            message: 'Es necesario ingresar una fecha de inicio.'
          }
        }}
        disabled={location?.state?.visualizarDatos}
      />
    </React.Fragment>
  )
}

export default ActividadSecundaria
